module.exports = __webpack_public_path__ + "static/media/bm-Icon.aa408d02.jpg";